// // import React from 'react';
// // import { Outlet } from 'react-router-dom';
// // import NewSidebar from './NewSidebar';
// // import NewTopbar from './NewTopbar';
// // import '../../../src/BrandPulse.css';

// // const DashboardLayout = () => {
// //   return (
// //     <div className="screen active" id="s-dash" style={{ display: 'flex' }}>
// //       <NewSidebar />
// //       <div className="main">
// //         <div className="scroll">
// //           <Outlet />
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default DashboardLayout;

// import React from 'react';
// import { Outlet } from 'react-router-dom';

// const DashboardLayout = () => {
//   return (
//     <div className="brand-audit-root">
//       <Outlet />
//     </div>
//   );
// };

// export default DashboardLayout;
// src/components/Layout/DashboardLayout.jsx
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useApp } from '../../contexts/AppContext';

const DashboardLayout = () => {
  const navigate = useNavigate();
  const { logout, user } = useApp();

  const handleLogout = async () => {
    await logout();
    navigate('/login'); // or '/' if you want to go to landing page
  };

  return (
    <div style={{ position: 'relative' }}>
      {/* Top‑right logout button */}
      <div style={{
        position: 'fixed',
        top: '16px',
        right: '20px',
        zIndex: 1000,
      }}>
        <button
          onClick={handleLogout}
          style={{
            background: 'rgba(255,255,255,0.9)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(107,79,160,0.2)',
            borderRadius: '30px',
            padding: '8px 18px',
            fontSize: '13px',
            fontWeight: 500,
            color: 'var(--thistle)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
            transition: 'all 0.2s',
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#fff'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.9)'}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          Logout
        </button>
      </div>

      {/* Main content */}
      <div className="brand-audit-root">
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;